import { render, staticRenderFns } from "./gclick-departamento-select.vue?vue&type=template&id=389b6a99&"
import script from "./gclick-departamento-select.vue?vue&type=script&lang=js&"
export * from "./gclick-departamento-select.vue?vue&type=script&lang=js&"
import style0 from "./gclick-departamento-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports